import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import _ from "lodash";
import {makeStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Service from "../services/Service";
import SettingsIcon from '@material-ui/icons/Settings';
import {getPortfolio, getPortfolios, updateUserPortfolio} from '../store/actions'
import { useHistory } from 'react-router'

import ListItemIcon from '@material-ui/core/ListItemIcon';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Link} from "react-router-dom";
import Tab from "@material-ui/core/Tab";
const service = new Service();

const useStyles = makeStyles((theme) => ({}));


export default function PortfolioList() {
    const dispatch = useDispatch();
    const history = useHistory();
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);

    const isLoading = useSelector(store => store.portfolios?.isLoad)
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        dispatch(getPortfolios());

    }, []);
    useEffect(() => {
        if (!isLoading){
            if (portfolioList.length > 0) {
                const savedId = localStorage.getItem('selectedPortfolioId');
                const savedIndex = savedId
                    ? portfolioList.findIndex(p => String(p.id) === savedId)
                    : -1;
                const index = savedIndex >= 0 ? savedIndex : 0;
                dispatch(updateUserPortfolio(index));
                dispatch(getPortfolio(portfolioList[index]?.id));
            }
            else {
               history.push('/welcome')
            }
        }
    }, [portfolioList]);
    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        dispatch(updateUserPortfolio(index))
        let portfolio = portfolioList[index]
        localStorage.setItem('selectedPortfolioId', String(portfolio.id))
        dispatch(getPortfolio(portfolio.id))

        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            {!_.isEmpty(portfolioList) ? (
                    <>
                        <List component="nav" aria-label="Device settings">
                            <ListItem
                                button
                                aria-haspopup="true"
                                aria-controls="lock-menu"
                                aria-label="when device is locked"
                                onClick={handleClickListItem}
                            >
                                <ListItemText primary={portfolioList[selectedIndex].name}/><ExpandMoreIcon/>
                            </ListItem>
                        </List>
                        <Menu
                            id="lock-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >                            
                            {_.map(portfolioList, (option, index, collection) => (
                                <MenuItem
                                    key={index}
                                    disabled={index === selectedIndex}
                                    selected={index === selectedIndex}
                                    divider={index === portfolioList.length - 1}
                                    onClick={(event) => handleMenuItemClick(event, index)}
                                >
                                    {option.name}
                                </MenuItem>
                            ))}
                            <MenuItem to={"/portfolios"} component={Link} onClick={handleClose}
                            >
                                Управление портфелями
                            </MenuItem>
                        </Menu>
                    </>
                ) :
                <List component="nav" aria-label="Device settings">
                    <ListItem
                        button
                        aria-haspopup="true"
                        aria-controls="lock-menu"
                        aria-label="when device is locked"
                        onClick={handleClickListItem}
                    >
                        <ListItemText primary={"Портфели отсутствуют"}/>
                    </ListItem>
                </List>}

        </div>

    );
}
